export const EMPLOYEE_MODALS = {
  createEmployee: 'createEmployee',
  deleteEmployee: 'deleteEmployee',
  createAbsence: 'createAbsence',
  employeeTableFilter: 'employeeTableFilter',
};
